import React, { useRef, useEffect, useState } from "react"
import { Select } from "radix-ui";
import { ChevronDown, ChevronUp } from "lucide-react"
import { cn } from "lib/utils"

export default function DropdownMenu({
  size="xs",
  theme="slate",
  name,
  value,
  placeholder="Choose...",
  selectfn,
  options,
  className="",
}:{
  size:"xs" | "sm" | "md" | "lg" | "full"
  theme:"slate" | "neutral"
  name:string
  value:string
  placeholder?:string
  selectfn:(value:any) => void
  options?:any 
  className?:string
}){

  return (
    <Select.Root value={value} onValueChange={selectfn}>
      <Select.Trigger asChild>
        <button
          className={cn(
            "w-full border border-solid rounded-sm inline-flex justify-between items-center outline-transparent outline outline-offset-2 text-sm text-gray-200 cursor-pointer px-1", 
            size === "xs" && "text-[.7rem] h-5.5 rounded-xs",
            size === "sm" && "text-xs h-7",
            size === "md" && "text-sm h-8",
            size === "lg" && "h-10",
            size === "full" && "h-full",
            theme === "slate" && "bg-slate-900 border-slate-600",
            theme === "neutral" && "bg-neutral-900 border-neutral-600",
            className,
          )}
        >
          <span>{ options.find( (opt:any) => opt.value === value )?.label || placeholder }</span>
          <ChevronDown className="w-4 h-4" />
        </button>
			</Select.Trigger>

      <Select.Content 
        position="popper"
        side="bottom"
        sideOffset={5}
        align="start"
        className={cn(
          "z-50 ml-[-1px] inline-flex relative flex-col justify-start items-start border border-solid rounded-sm text-sm text-gray-200 overflow-hidden",
          size === "xs" && "text-[.7rem] rounded-xs",
          size === "sm" && "text-xs",
          size === "md" && "text-sm",
          size === "lg" && "text-base",
          theme === "slate" && "bg-slate-900 border-slate-700",
          theme === "neutral" && "bg-neutral-900 border-neutral-600",
        )}
        style={{ minWidth: "var(--radix-select-trigger-width)", width: "var(--radix-select-trigger-width)" }}
      >
        <Select.Viewport className="absolute w-full p-[1px]">
          { options.map( ({ value, label }: { value: string, label: string }) => (
            <Select.Item 
              key={value}
              value={value}
              textValue={value}
              className={cn(
                "block w-full flex cursor-pointer border-none outline-none",
                size === "xs" && "pl-[7px] pt-[3px] py-[2px]",
                size === "sm" && "pl-[7px] pt-[3px] py-[2px]",
                size === "md" && "pl-[7px] pt-[3px] py-[2px]",
                size === "lg" && "pl-[7px] pt-[3px] py-[2px]",
                size === "full" && "pl-[7px] pt-[3px] py-[2px]",
                theme === "slate" && "hover:bg-slate-800",
                theme === "neutral" && "hover:bg-neutral-600",
              )}
            >
              <Select.ItemText>{label}</Select.ItemText>
            </Select.Item>
          )) }
        </Select.Viewport>
      </Select.Content>

    </Select.Root>
  )
}